var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgToyotaDriverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 33,
    viewBox: "0 0 26 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 28C0.276842 24.1674 1.54646 21.575 2.67571 19.9872C3.58931 18.7024 5.03577 17.9759 6.5489 18.0006L13.0217 18.1066H12.9783L19.4514 18.0006C20.9645 17.9759 22.4107 18.7024 23.3246 19.9872C24.4535 21.575 25.7234 24.1674 26 28C26 28 22.6759 28 21.0139 28C17.2399 28 11.9408 28 5.11674 28C3.49707 28 0 28 0 28Z",
    fill: "#E50C22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2962 15.9352V15.9352C9.83324 15.9352 7 13.102 7 9.63896V7.29623C7 3.83324 9.83324 1 13.2962 1C16.7592 1 19.5925 3.83324 19.5925 7.29623V9.63896C19.5925 13.102 16.7592 15.9352 13.2962 15.9352Z",
    stroke: "#696969",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5275 12.5456C12.5275 12.5456 15.3356 13.3946 16.6235 10.491",
    stroke: "#696969",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 25,
    r: 7,
    stroke: "#696969",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 25,
    r: 2,
    fill: "#D9DDE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8025 24.6268L19.2307 29.4928L20.2307 27.7607L12.8025 24.6268Z",
    fill: "#D9DDE9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4641 24.6268L7.03591 29.4928L6.03591 27.7607L13.4641 24.6268Z",
    fill: "#D9DDE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9845 25.0715L11.9845 18.0715H13.9845L12.9845 25.0715Z",
    fill: "#D9DDE9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35631 23.986C3.84679 23.4133 3.76392 22.5777 4.15103 21.9161L5.1393 20.2271C5.70841 19.2545 6.99851 18.9959 7.89849 19.6741C8.72925 20.3001 8.89523 21.4811 8.2692 22.3118L7.09152 23.8747C6.41927 24.7668 5.09881 24.8205 4.35631 23.986Z",
    fill: "white",
    stroke: "#696969",
    strokeWidth: 1.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6437 23.986C22.1532 23.4133 22.2361 22.5777 21.849 21.9161L20.8607 20.2271C20.2916 19.2545 19.0015 18.9959 18.1015 19.6741C17.2707 20.3001 17.1048 21.4811 17.7308 22.3118L18.9085 23.8747C19.5807 24.7668 20.9012 24.8205 21.6437 23.986Z",
    fill: "white",
    stroke: "#696969",
    strokeWidth: 1.4
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToyotaDriverIcon);
export default __webpack_public_path__ + "static/media/toyota-driver-icon.e2e7b3ce.svg";
export { ForwardRef as ReactComponent };